import { createFileRoute } from '@tanstack/react-router'

import { EmailVerification } from '@/containers/Account/EmailVerification'

export const Route = createFileRoute(
  '/_unauthenticated/setup/email-verification'
)({
  component: EmailVerification,
})
